import { prefix } from '@goldwasserexchange/react-topmodel';

export const radioListInputPrefixer = prefix('RadioList');
